import { Record } from "immutable";

const FreeOpinionRecord = Record({
  id: "",
  number: "",
  attr: "",
  answer: "",
  initAnswer: "",
  isEdit: false
});

class FreeOpinion extends FreeOpinionRecord {}

export default FreeOpinion;



// WEBPACK FOOTER //
// ./src/models/FreeOpinion.js